import React, { useState } from 'react';
import { useRecoilValue } from 'recoil';

import styled from '@emotion/styled';

import { Menu, MenuDropdown, Image } from '@Calix-Commerce/design-system/components';
import { Flex } from '@Calix-Commerce/design-system/layout';
import defaultAvatarImg from '@Calix-Commerce/design-system/assets/img/default-avatar.png';

import { currentAccountState } from 'state/atoms';

import { InfoBlock } from './InfoBlock';
import { ContactForm } from './ContactForm';
import { PictureWrapper } from './styledComponents';

const Title = styled.div`
  width: ${({ hasAccountLead }) => (hasAccountLead ? '118px' : '150px')};
  margin-right: 0.7rem;
  margin-bottom: 0.3rem;
  line-height: 1.4;
`;

const Name = styled.div`
  font-weight: bold;
`;

const RepresentativeMenu = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isContactFormOpen, setIsContactFormOpen] = useState(false);
  const account = useRecoilValue(currentAccountState);

  const accountLead = account.accountLead || {};

  const title = account.accountLead ? 'Your Customer Operations Rep.' : 'Customer Operations';

  const closeDropdown = () => {
    setIsContactFormOpen(false);
    setIsDropdownOpen(false);
  };

  return (
    <Menu
      isOpen={isDropdownOpen}
      onClick={() => (isDropdownOpen ? closeDropdown() : setIsDropdownOpen(true))}
      onClickOutside={closeDropdown}
      disableFocusRipple
    >
      <Flex>
        <PictureWrapper>
          <Image
            src={accountLead.userImageUrl || defaultAvatarImg}
            alt={title}
            fallbackSrc={defaultAvatarImg}
          />
        </PictureWrapper>
        <div style={{ textAlign: 'left' }}>
          <Title hasAccountLead={account.accountLead}>{title}</Title>
          {accountLead.name && <Name>{accountLead.name}</Name>}
        </div>
        <MenuDropdown isOpen={isDropdownOpen}>
          {isContactFormOpen ? (
            <ContactForm accountLead={accountLead} handleClose={closeDropdown} />
          ) : (
            <InfoBlock
              accountLead={accountLead}
              handleClose={closeDropdown}
              handleContactClick={() => setIsContactFormOpen(true)}
            />
          )}
        </MenuDropdown>
      </Flex>
    </Menu>
  );
};
export { RepresentativeMenu };
